// @todo: Migrate to @wandb/components. For more details see:
// https://www.notion.so/wandbai/Migrating-components-207e2f5c7ef380129201f72a5770a8db
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components/Button';
import React, {useCallback} from 'react';

import {useWorkspaceDrawerContext} from '../../WorkspaceDrawerContextProvider';

export const CloseButton = () => {
  const {closeWorkspaceDrawer} = useWorkspaceDrawerContext();
  const onClose = useCallback(
    () => closeWorkspaceDrawer(),
    [closeWorkspaceDrawer]
  );

  return (
    <Button
      data-test="workspace-drawer-close-button"
      variant="ghost"
      icon="close"
      onClick={onClose}
    />
  );
};
